import React from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import Button from "../elements/Button";
import {TimelineLite} from "gsap";

const PricingError = (props) => {

	const handleCloseHover = (event) => {
		let el = event.currentTarget,
			tl = new TimelineLite();

		tl.to(el, 0.2, {scale: 1.3});
		tl.to(el, 0.2, {scale: 1});
	};

	return (
		<div className="pricing-error" id={props.id}>
			<a href="#" className="close" onMouseEnter={event => handleCloseHover(event)} onClick={props.handleClose.bind(this)} title="Close" />
			<div className="row">
				<div className="col-md-3 col-md-offset-2">
					<BrowserView>
						<img src="/images/phone-dude.png" alt="" />
					</BrowserView>
				</div>
				<div className="col-md-6 col-xs-12">
					{props.children}
					<MobileView>
						<Button
							action="tel: 1300 393 835"
							image="/images/btn-phone.svg"
							alt="Call Us"
						/>
					</MobileView>
				</div>
			</div>
		</div>
	);

};

export default PricingError;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/PricingError.js